import { render, staticRenderFns } from "./Bonus.vue?vue&type=template&id=cfab36da&"
import script from "./Bonus.vue?vue&type=script&lang=ts&"
export * from "./Bonus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports